export default __webpack_public_path__ + "static/media/pin-1.155036b1.svg";